module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"availability":"Disponibilité en magasin"},"en":{"availability":"In store availability"},"de":{"availability":"Verfügbarkeit im Geschäft"},"es":{"availability":"Disponibilidad en tienda"},"it":{"availability":"Disponibilità in negozio"},"nl":{"availability":"Beschikbaarheid in de winkels"},"pt":{"availability":"Disponibilidade em stock"}}')
  delete Component.options._Ctor
}
